// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2j5Ji","centerPosition":"styles_centerPosition__1tiip","show":"styles_show__1aDeg"};